<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
      no-click-animation
  >
    <v-card>
      <v-toolbar
          dark
          dense
          color="primary"
          elevation="1"
          tile
      >
        <v-btn
            icon
            dark
            @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Mass Campaigns</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-subheader>Follow this wizard to create campaigns for selected affiliates and offers.</v-subheader>
      <steppers></steppers>
    </v-card>
  </v-dialog>
</template>

<script>
import Steppers from '@/components/pages/multipleCampaignsCreation/Steppers'

export default {
  name: 'MassCampaigns',
  components: {
    Steppers
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  model: {
    prop: 'open',
    event: 'toggle'
  },
  mounted() {
    this.dialog = this.open
  },
  data () {
    return {
      dialog: this.open,
    }
  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    open() {
      this.dialog = this.open
    },
  }
}
</script>

<style scoped>

</style>
